<app-dialog-container>
    <div fxFlex fxLayout="column" fxLayoutGap="20">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <h2 mat-dialog-title>Configuração de Tarifas</h2>
        </div>

        <form [formGroup]="feeForm" (ngSubmit)="onSubmit()">
            <div fxFlex fxLayout="column" fxLayoutGap="20">
                <div fxFlex fxLayout="column" fxLayoutGap="10">
                    <h3>Informações da Conta</h3>
                    <app-input
                        [config]="getFieldConfig('numero_cnpj')"
                        [group]="feeForm">
                    </app-input>
                </div>
     
                <div fxFlex fxLayout="column" fxLayoutGap="15">
                    <h3>Tarifas em Porcentagem (%)</h3>
                    <div fxFlex fxLayout="row" fxLayoutWrap fxLayoutGap="20">
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('pixCashin')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('pixStaticCashin')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('boletoCashin')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('pixCashout')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('pixCashinSemStatus')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                    </div>
                </div>

                <div fxFlex fxLayout="column" fxLayoutGap="15">
                    <h3>Tarifas em Valor (R$)</h3>
                    <div fxFlex fxLayout="row" fxLayoutWrap fxLayoutGap="20">
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('pixCashinValue')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('pixStaticCashinValue')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('boletoCashinValue')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('pixCashoutValue')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                        
                        <div fxFlex="1 1 30%" fxLayout="column">
                            <app-input
                                [config]="getFieldConfig('pixCashinSemStatusValue')"
                                [typeCes]="typeCes"
                                [group]="feeForm">
                            </app-input>
                        </div>
                    </div>
                </div>
                

            </div>
        </form>
        <div fxFlex fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
            <button type="submit" mat-raised-button color="primary" (click)="onSubmit()" *ngIf="typeCes != typeCesEnum.SHOW" 
                [disabled]="feeForm.invalid">
                Salvar Configuração
            </button>
            <button type="button" mat-raised-button color="primary" (click)="typeCes = typeCesEnum.EDIT" *ngIf="typeCes == typeCesEnum.SHOW">
                Editar Configuração
            </button>
        </div>
    </div>
</app-dialog-container>
